import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  contentTab: {
    margin: '10px 0 0 0',
    display: 'flex'
  }
}))
